import React, { useState, useEffect } from "react";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
import { useLocation, useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API";
import ROUTES_NAVIGATION from "../../../../../../routes/routes";
import Loader from "../../../../../customComponents/CustomLoader";
import Swal from "sweetalert2";

const EditCampaign = () => {
  const [formData, setFormData] = useState({});
  const [sourceOptions, setSourceOptions] = useState([]);
  const [publisherOptions, setPublisherOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [campaign, setCAmpaign] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const { data } = location.state || {};
  const Token = localStorage.getItem("authToken");
  const [userTypedd, setUserTypedd] = useState([]);
  const userType = localStorage.getItem("UserType");
  const businessPartnerId = data?.business_partner_id
  const authToken = localStorage.getItem("authToken");

  useEffect(() => {
    userTypedropdown();
  }, []);

  const userTypedropdown = async () => {
    try {
      const response = await axiosInstance.get("/bp-onboard/bplist", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = response.data.data.data;
      const userTypeOptions = data.map((user) => ({
        value: user.onboard_id,
        label: user.bp_name,
      }));
      setUserTypedd(userTypeOptions);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchSourceOptions();
    
  }, [formData?.business_partner_id]);

  const fetchSourceOptions = async () => {
    
    try {
      const authToken = localStorage.getItem("authToken");
      const business_partner_id = formData?.business_partner_id?formData?.business_partner_id:businessPartnerId; // Replace with actual business_partner_id
      const response = await axiosInstance.post(
        "/source/list",
        {
          business_partner_id,
          orderBy: "source_id desc",
          page: 0,
          pageSize: 100,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      const options = response.data.data.data.map((source) => ({
        label: source.source_name,
        value: source.source_id,
      }));

      setSourceOptions(options);
      fetchPublisherOptions();
    } catch (error) {
      console.error("Error fetching source options:", error);
    }
  };

  const fetchPublisherOptions = async () => {
    try {
      const authToken = localStorage.getItem("authToken");
      const business_partner_id =userType==="superadmin"?formData?.business_partner_id:businessPartnerId 
      const response = await axiosInstance.post(
        "/publisher/list",
        {
          business_partner_id,
          orderBy: "publisher_id desc",
          page: 0,
          pageSize: 100,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      const options = response.data.data.data.map((publisher) => ({
        label: publisher.publisher_name,
        value: publisher.publisher_id,
      }));

      setPublisherOptions(options);
    } catch (error) {
      console.error("Error fetching publisher options:", error);
    }
  };

  const handleFormSubmit = async (formData) => {
    const errors = {};
    let isValid = true;
    CampaignInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        }
      }
    });
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

    
    const result = await Swal.fire({
      title: "Confirmation",
      text: "Are you sure you want to update this record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        try {
          setLoading(true); 
          const payload = {
            source_id: formData.source_id,
            publisher_id: formData.publisher_id,
            campaign_name: formData.campaign_name,
            campaign_desc: formData.campaign_desc,
            status: formData.status === "Active" ? 1 : 0,
          };
          if (userType === "superadmin") {
            payload.business_partner_id = formData.business_partner_id;
          } else {
            payload.business_partner_id = businessPartnerId;
          }

          const authToken = localStorage.getItem("authToken");
          const response = await axiosInstance.patch(
            `/campaign/update/${data.campaign_id}`,
            payload,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${authToken}`,
              },
            }
          );
          if (response.status === 200) {
            Swal.fire({
              title: "Success",
              text: "Campaign updated successfully!",
              icon: "success",
              confirmButtonText: "OK",
            }).then(() => {
              navigate(ROUTES_NAVIGATION.CAMPAIGNLIST);
            });
          }
        } catch (error) {
          console.error("Error updating campaign:", error);

          const errorMessage =
            error.response?.data?.message ||
            "An error occurred while processing your request.";
          Swal.fire({
            title: "Something went wrong",
            text: errorMessage,
            icon: "error",
            confirmButtonText: "OK",
          });
        } finally {
          setLoading(false);
        }
      },
    });

    if (!result.isConfirmed) {
      setLoading(false);
    }
  };

  const fetchCAmpaignEdit = async () => {
    try {
      const response = await axiosInstance.get(
        `/campaign/edit/${data.campaign_id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Token}`,
          },
        }
      );
      const fetchedData = response.data.data;
    
      const formatedData = {
        business_partner_id: fetchedData.business_partner_id,
        publisher_id: fetchedData.publisher_id,
        source_id: fetchedData.source_id,
        campaign_name: fetchedData.campaign_name,
        campaign_desc: fetchedData.campaign_desc,
        status: fetchedData.status === 1 ? "Active" : "Inactive",
      };
      setFormData(formatedData);
      setCAmpaign(fetchedData);
      console.log(formData);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchCAmpaignEdit();
  }, []);

  const CampaignInputs = [
    ...(userType === "superadmin"
      ? [
          {
            name: "business_partner_id",
            label: "Business Partner",
            type: "dropdown",
            required: true,
            options: userTypedd,
            gridClass: "col-lg-4",
            validation: {
              required: true,
              pattern: /^[A-Za-z0-9 ]*$/,
              message: "Only alphabets and digits are allowed",
            },
          },
        ]
      : []),
    {
      name: "campaign_name",
      label: "Campaign Name",
      type: "text",
      required: true,
      validation: {
        required: true,
        pattern: /^[A-Za-z0-9-\s]*$/,
        message: "Special Symbols are not allowed*",
      },
      gridClass: "col-lg-4",
    },
    {
      name: "campaign_desc",
      label: "Campaign Description",
      type: "text",
      options: [],
      required: true,
      validation: { required: true },
      gridClass: "col-lg-4",
    },
    {
      name: "source_id",
      label: "Source",
      type: "dropdown",
      options: [],
      required: true,
      validation: { required: true },
      gridClass: "col-lg-4",
    },
    {
      name: "publisher_id",
      label: "Publisher ",
      type: "dropdown",
      options:[],
      required: true,
      validation: { required: true },
      gridClass: "col-lg-4",
    },

    {
      name: "status",
      label: "Status",
      type: "dropdown",
      required: true,
      options: [
        { label: "Active", value: "Active" },
        { label: "Inactive", value: "Inactive" },
      ],
      validation: {
        required: true,
        message: "Status is required",
      },
      gridClass: "col-lg-4",
    },
  ];

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <div
            className="backbutton mt-2 mb-2"
            onClick={() => navigate(ROUTES_NAVIGATION.CAMPAIGNLIST)}
          >
            <img src={backicon} alt="back" />
            <span className="backbtntitle">Edit Campaign</span>
          </div>
          <div className="form-container">
            <span className="cust-det-title mt-2 mb-2">
              Please Enter Campaign Details
            </span>
            <DynamicForm
              formConfig={CampaignInputs.map((input) => {
                if (input.name === "source_id")
                  return { ...input, options: sourceOptions };
                if (input.name === "publisher_id")
                  return { ...input, options: publisherOptions };
                return input;
              })}
              formData={formData}
              setFormData={setFormData}
              onSubmit={handleFormSubmit}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
            />
          </div>
          <div className="btncontainer mt-3">
            <button
              onClick={() => handleFormSubmit(formData)}
              className="submit-btn"
            >
              Submit
            </button>
          </div>
        </>
      )}
    </>
  );
};

export default EditCampaign;
